var Mesh = function (data) {
  this.data = data;
  this.idx = 0;
};

Mesh.SVM_DECODE_STEP = 10000;

Mesh.SVM_CONTENT_VERTEX = 1;
Mesh.SVM_CONTENT_FACE = 2;
Mesh.SVM_CONTENT_MATERIAL = 4;
Mesh.SVM_CONTENT_NORMAL = 8;
Mesh.SVM_CONTENT_BSP = 16;
Mesh.SVM_CONTENT_GROUPS = 128;
Mesh.SVM_CONTENT_VCOLOR = 512;
Mesh.SVM_CONTENT_CURVE = 1024;
Mesh.SVM_CONTENT_NURBS = 2048;
Mesh.SVM_CONTENT_FONT = 4096;
Mesh.SVM_CONTENT_SLICES = 8192;
Mesh.SVM_CONTENT_FEATURES = 16384;
Mesh.SVM_CONTENT_MARKUPS = 32768;
Mesh.SVM_CONTENT_OVERHANG = 65536;
Mesh.SVM_CONTENT_SUPPORT = 131072;
Mesh.SVM_CONTENT_OVERHANG_BOUNDARIES = 262144;

Mesh.SVM_CONTENT_LASERCUT_POINTS = 1;
Mesh.SVM_CONTENT_LASERCUT_PATHS = 2;
Mesh.SVM_CONTENT_LASERCUT_SHAPES = 4;
Mesh.SVM_CONTENT_LASERCUT_PROPERTIES = 8;

Mesh.SVM_LASERCUT_PROPERTY_NUM_OBJECTS = 1;

Mesh.SVM_FLAGS_ZLIB = 1;
Mesh.SVM_FLAGS_JPEG = 2;
Mesh.SVM_FLAGS_EXACT = 4;
Mesh.SVM_FLAGS_PNG = 8;
Mesh.SVM_FLAGS_LASERCUT = 16;

Mesh.SVM_MATTYPE_NONE = 0;
Mesh.SVM_MATTYPE_COLOR = 1;
Mesh.SVM_MATTYPE_TEXTURE = 2;
Mesh.SVM_MATTYPE_FULL = 3;

Mesh.FACEINFO_SELECTED = 1 << 0;
Mesh.FACEINFO_TEXCOORD = 1 << 1;

Mesh.FACEINFO_V0_SELECTED = 1 << 2;
Mesh.FACEINFO_E0_SELECTED = 1 << 3;
Mesh.FACEINFO_V1_SELECTED = 1 << 4;
Mesh.FACEINFO_E1_SELECTED = 1 << 5;
Mesh.FACEINFO_V2_SELECTED = 1 << 8;
Mesh.FACEINFO_E2_SELECTED = 1 << 9;

Mesh.FACEINFO_E0_BORDER = 1 << 10;
Mesh.FACEINFO_E0_NON_MANIFOLD = 1 << 11;
Mesh.FACEINFO_E1_BORDER = 1 << 12;
Mesh.FACEINFO_E1_NON_MANIFOLD = 1 << 13;
Mesh.FACEINFO_E2_BORDER = 1 << 16;
Mesh.FACEINFO_E2_NON_MANIFOLD = 1 << 17;

Mesh.FACEINFO_V0_NON_MANIFOLD = 1 << 18;
Mesh.FACEINFO_V1_NON_MANIFOLD = 1 << 19;
Mesh.FACEINFO_V2_NON_MANIFOLD = 1 << 20;

Mesh.FACEINFO_OVERHANG = 1 << 24;
Mesh.FACEINFO_V0_OVERHANG = 1 << 25;
Mesh.FACEINFO_V1_OVERHANG = 1 << 26;
Mesh.FACEINFO_V2_OVERHANG = 1 << 27;

Mesh.FACEINFO_SUPPORT = 1 << 28;

(Mesh.LSR_CONFORMANT = 1), (Mesh.LSR_RASTERIZED = 2);

Mesh.LSR_SHAPE_FLAG_STROKE_COLOR = 1;
Mesh.LSR_SHAPE_FLAG_LINE_WIDTH = 2;
Mesh.LSR_SHAPE_FLAG_FILL_COLOR = 4;
Mesh.LSR_SHAPE_FLAG_TEXTURE = 8;

Mesh.prototype.decodeFaceInfo = function (fi) {
  var extend;
  var mi = -1;
  var flags = 0;
  var shift = 0;

  do {
    extend = false;
    var f = this.readByte();

    if ((f & 0x80) == 0) {
      var c;
      c = (f & 0x7f) << 24;
      f = this.readByte();
      c |= (f & 0xff) << 16;
      f = this.readByte();
      c |= (f & 0xff) << 8;
      f = this.readByte();
      c |= f & 0xff;

      mi = c;
      if (this.material[mi].texture) flags |= Mesh.FACEINFO_TEXCOORD;
    } else if (f == 0x80) {
      throw new Error("unsupported face color");
    } else if (f == 0x81) {
      throw new Error("unsupported face color");
    } else if ((f & 0xc0) == 0xc0) {
      /* flags & extension */
      flags |= (f & 0x3f) << shift;
      shift += 8;
      extend = true;
    }
  } while (extend);

  this.face_mi[fi] = mi;
  this.face_flag[fi] = flags;

  return flags;
};

Mesh.prototype.decodeSubMaterial = function () {
  var len = this.readInt();
  var type = this.readInt();
  len -= 4;
  //log("submaterial type=" + type + "len=" + len);

  var submaterial = null;

  if (type == Mesh.SVM_MATTYPE_COLOR) {
    submaterial = {
      color: {
        a: this.readByte(),
        r: this.readByte(),
        g: this.readByte(),
        b: this.readByte(),
      },
    };
  } else if (type == Mesh.SVM_MATTYPE_TEXTURE) {
    // use data: URI scheme to encode texture
    var image_inline = this.readBase64String(len);
    var image = new Image();
    image.loaded = false;
    image.onload = function () {
      this.loaded = true;
    };
    image.src = "data:image/jpeg;base64," + image_inline;
    submaterial = {
      texture: image,
    };
  }

  return submaterial;
};

Mesh.prototype.decodeMaterial = function (mi, material_length) {
  var magic = this.readInt();
  material_length -= 4;

  if (magic != 0x4d415430) {
    // MAT0
    throw new Error("invalid material format");
  }

  var type = this.readInt();
  var name_len = this.readInt();
  material_length -= 8;
  var name = this.readString(name_len);
  material_length -= name_len;
  //	//log("material type=" + type + " name=" + name);

  if (type == Mesh.SVM_MATTYPE_COLOR) {
    this.material[mi] = {
      color: {
        a: this.readByte(),
        r: this.readByte(),
        g: this.readByte(),
        b: this.readByte(),
      },
    };
  } else if (type == Mesh.SVM_MATTYPE_TEXTURE) {
    // use data: URI scheme to encode texture
    var image_inline = this.readBase64String(material_length);
    var image = new Image();
    image.loaded = false;
    image.onload = function () {
      this.loaded = true;
    };
    image.src = "data:image/jpeg;base64," + image_inline;
    this.material[mi] = {
      texture: image,
    };
  } else if (type == Mesh.SVM_MATTYPE_FULL) {
    var len, type;
    this.material[mi] = {};
    this.material[mi]["ambient"] = this.decodeSubMaterial();
    this.material[mi]["diffuse"] = this.decodeSubMaterial();
    this.material[mi]["specular"] = this.decodeSubMaterial();
    this.material[mi]["emissive"] = this.decodeSubMaterial();
    this.material[mi]["transmit"] = this.decodeSubMaterial();
    this.material[mi]["shininess"] = this.readFloat();
    this.material[mi]["ior"] = this.readFloat();
    this.material[mi]["normalmap"] = this.decodeSubMaterial();
  }
};

Mesh.prototype.decodeFaceContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_FACE) != 0) {
    this.face_size = this.readInt();
    this.face_count = this.readInt();
    this.face_size -= 4;
    this.vertex_ibits = Math.floor(
      (this.face_size * 8) / (this.face_count * 4)
    );

    //log("face count " + this.face_count);
    //log("vertex index size " + this.vertex_ibits);

    if (this.version == 2) {
      this.handle_count = this.readInt();
      this.eb = new EdgeBreaker(this.data);
      //log("handles " + this.handle_count);
      this.eb.decodeConnectivity(this.face_count, this.handle_count);

      var array = new Array(3 * this.face_count);
      for (i = 0; i < this.face_count; i++) {
        array[3 * i] = this.eb.V[0 + 4 * i];
        array[3 * i + 1] = this.eb.V[1 + 4 * i];
        array[3 * i + 2] = this.eb.V[2 + 4 * i];
      }
      this.alignToByte();
      setTimeout(function () {
        done(array);
      }, 0);
    } else {
      var array = this.readArrayOfBits(this.vertex_ibits, this.face_count * 4);
      for (var i = 0; i < this.face_count; i++) {
        var fn = array[4 * i];
        if (fn != 3) throw new Error("polygonal faces not supported " + i);
        array[3 * i] = array[4 * i + 1];
        array[3 * i + 1] = array[4 * i + 2];
        array[3 * i + 2] = array[4 * i + 3];
        //			//log("index " + i0 + "," + i1 + "," + i2);
      }
      array.length = this.face_count * 3;
      this.alignToByte();
      setTimeout(function () {
        done(array);
      }, 0);
    }
  } else {
    setTimeout(function () {
      done([]);
    }, 0);
  }
};

Mesh.prototype.decodeMaterialContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_MATERIAL) != 0) {
    this.face_mi = [];
    this.face_uv = [];
    this.face_flag = [];
    this.material = [];

    this.material_size = this.readInt();
    this.matface_count = this.readInt();
    this.material_size -= 4;
    this.material_count = this.readInt();
    this.material_size -= 4;

    //log("material_size " + this.material_size);
    //log("material face count " + this.matface_count);
    //log("material count " + this.material_count);

    for (i = 0; i < this.material_count; i++) {
      var material_length = this.readInt();
      this.decodeMaterial(i, material_length);
      this.material_size -= 4 + material_length;
    }

    var face_mi_size = this.readInt();
    this.material_size -= 4;

    //log("material index size " + face_mi_size);

    var has_uv = false;
    for (var i = 0; i < this.matface_count; i++)
      if (this.decodeFaceInfo(i) & Mesh.FACEINFO_TEXCOORD) has_uv = true;

    var texcoord_size = this.readInt();
    //log("texture coord size " + texcoord_size);

    if (has_uv) {
      Utils.loop(
        this,
        0,
        this.matface_count,
        Mesh.SVM_DECODE_STEP,
        function (i) {
          if ((this.face_flag[i] & Mesh.FACEINFO_TEXCOORD) != 0) {
            for (var j = 0; j < 6; j++)
              this.face_uv[6 * i + j] = this.readFloat();
          }
        },
        function () {
          this.alignToByte();
          setTimeout(function () {
            done();
          }, 0);
        },
        abort
      );
    } else {
      setTimeout(function () {
        done();
      }, 0);
    }
  } else {
    setTimeout(function () {
      done();
    }, 0);
  }
};

Mesh.prototype.decodeVertexContent = function (indices, done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_VERTEX) == 0) {
    //log("No vertex data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  } else {
    this.vertex_size = this.readInt();
    this.vertex_count = this.readInt();
    this.vertex_size -= 4;
    this.vertex_qbits = this.readInt();
    this.vertex_size -= 4;
    //log("vertex_count: " + this.vertex_count);
    //log("vertex_qbits: " + this.vertex_qbits);

    var m = this.vertex_count;
    for (var i = 0; m != 0; i++) m >>= 1;
    this.vertex_ibits = i;
    //log("vertex index size " + this.vertex_ibits);
  }

  if ((this.content & Mesh.SVM_CONTENT_FACE) == 0) {
    this.face_count = this.vertex_count / 3;
    for (i = 0; i < fn; i++) indices.push(j * 3, j * 3 + 1, j * 3 + 2);
  }
  var fn = this.face_count;

  //log("decode " + this.vertex_count + " vertices");
  var vertex = [];
  vertex.length = 3 * this.vertex_count;

  if (this.version == 2) {
    var T = new Date().getTime();
    this.eb.decodeVertexInit(this.vertex_count, this.vertex_qbits);

    for (var i = 0; i < this.face_count; i++) {
      if (this.eb.decodeNextTriangle() < 0) {
        //log("read error (triangle " + i + "/" + this.face_count + ")");
        throw new Error("read error");
      }
    }
    //log("decoded triangle in " + ((new Date()).getTime() - T) + " ms");
    this.eb.getVertices(vertex);
  } else {
    var array;

    if (this.vertex_qbits == 16)
      array = this.readArrayOfShorts(this.vertex_count * 3); // optimized
    else array = this.readArrayOfBits(this.vertex_qbits, this.vertex_count * 3);

    var k = 0;
    var s = 1.0 / (1 << (this.vertex_qbits - 1));

    for (var i = 0; i < this.face_count; i++) {
      for (var j = 0; j < 3; j++) {
        var vj = indices[3 * i + j];
        if (typeof vertex[3 * vj] == "undefined") {
          var px, py, pz;
          px = (array[k++] + 0.5) * s - 1.0;
          py = (array[k++] + 0.5) * s - 1.0;
          pz = (array[k++] + 0.5) * s - 1.0;
          vertex[3 * vj + 0] = px;
          vertex[3 * vj + 1] = py;
          vertex[3 * vj + 2] = pz;
        }
      }
    }

    // decode missing vertices
    for (var j = 0; j < this.vertex_count; j++) {
      if (typeof vertex[3 * j + 0] == "undefined") {
        var px, py, pz;
        px = (array[k++] + 0.5) * s - 1.0;
        py = (array[k++] + 0.5) * s - 1.0;
        pz = (array[k++] + 0.5) * s - 1.0;
        vertex[3 * j + 0] = px;
        vertex[3 * j + 1] = py;
        vertex[3 * j + 2] = pz;
      }
    }
  }

  this.alignToByte();

  var x, y, z, minpx, minpy, minpz, maxpx, maxpy, maxpz;
  if (this.vertex_count) {
    maxpx = minpx = vertex[0];
    maxpy = minpy = vertex[1];
    maxpz = minpz = vertex[2];
  }

  for (var j = 1; j < this.vertex_count; j++) {
    x = vertex[3 * j + 0];
    y = vertex[3 * j + 1];
    z = vertex[3 * j + 2];
    if (x < minpx) minpx = x;
    if (x > maxpx) maxpx = x;
    if (y < minpy) minpy = y;
    if (y > maxpy) maxpy = y;
    if (z < minpz) minpz = z;
    if (z > maxpz) maxpz = z;
  }

  if (this.vertex_count) {
    this.minpx = minpx;
    this.minpy = minpy;
    this.minpz = minpz;
    this.maxpx = maxpx;
    this.maxpy = maxpy;
    this.maxpz = maxpz;
    //log([minpx, minpy, minpz, maxpx, maxpy, maxpz]);
  } else {
    this.minpx =
      this.minpy =
      this.minpz =
      this.maxpx =
      this.maxpy =
      this.maxpz =
        0;
  }

  setTimeout(function () {
    done(vertex);
  }, 0);
};

Mesh.prototype.decodeVertexColorContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_VCOLOR) == 0) {
    //log("No vertex color data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  } else {
    this.vcolor_size = this.readInt();

    var ilog2 = function (m) {
      for (var i = 0; m != 0; i++) m >>= 1;
      return i;
    };
    var material_index_bits = ilog2(this.material_count + 1);
    var material_none_symbol = (1 << material_index_bits) - 1;

    this.vcolor = new Array();

    for (var j = 0; j < this.vertex_count; j++) {
      var mi = this.readBits(material_index_bits);
      if (mi >= this.material_count) mi = -1;
      if (mi == material_none_symbol) mi = -1;
      this.vcolor[j] = mi;
    }
    this.alignToByte();
  }

  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.scaleAndTranslate2D = function (p) {
  return [
    (p[0] * this.scale) / 2 + this.center_x,
    (p[1] * this.scale) / 2 + this.center_y,
  ];
};

Mesh.prototype.decodeSlicePolygonContour = function (s) {
  var n = this.readInt();
  var contour = new Float32Array(2 * n);
  var px, py;
  px = 0;
  py = 0;
  for (var i = 0; i < n; i++) {
    var x, y;
    if (i == 0) {
      //no varint for first point
      x = this.readBits(16);
      y = this.readBits(16);
    } else {
      x = this.readVarInt();
      y = this.readVarInt();
    }
    var p = [(x + px + 0.5) * s - 1.0, (y + py + 0.5) * s - 1.0];
    var _p = this.scaleAndTranslate2D(p);
    contour[2 * i] = _p[0];
    contour[2 * i + 1] = _p[1];
    px = x + px;
    py = y + py;
  }
  return contour;
};

Mesh.prototype.decodeSlicePolygon = function (s) {
  var nContour = this.readInt();
  var polygon = [];
  for (var i = 0; i < nContour; i++) {
    polygon.push(this.decodeSlicePolygonContour(s));
  }
  return polygon;
};

Mesh.prototype.decodeErrorList = function (s) {
  var errn = this.readInt();
  var errors = [];
  for (var i = 0; i < errn; i++) {
    var p = [
      (this.readBits(16) + 0.5) * s - 1.0,
      (this.readBits(16) + 0.5) * s - 1.0,
    ];
    p = this.scaleAndTranslate2D(p);
    p.push(this.readBits(8));
    errors.push(p);
  }
  return errors;
};

Mesh.prototype.decodeSliceContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_SLICES) == 0) {
    //log("No slice data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  }
  var slice_qbits = 16;
  var s = 1.0 / (1 << (slice_qbits - 1));
  this.slice_size = this.readInt();
  this.slice_thickness = this.readFloat();
  this.sln = this.readInt();
  //log("slice size: " + this.slice_size
  //		+ "slice thk: " + this.slice_thickness
  //		+ "slice number: " + this.sln);
  this.slices = [];
  this.paths = [];
  this.errors = {};
  for (var j = 0; j < this.sln; j++) {
    this.slices.push(this.decodeSlicePolygon(s));
    this.paths.push(this.decodeSlicePolygon(s));
    var errors = this.decodeErrorList(s);
    if (errors.length != 0) this.errors[j] = errors;
  }
  this.alignToByte();
  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.initializeOverhangGroups = function () {
  if ((this.content & Mesh.SVM_CONTENT_OVERHANG) == 0) {
    return;
  }
  this.overhang_group_data = [];
  if (this.group) {
    for (var i = 0; i < this.group.length; i++) {
      if (this.group && this.group.length > i) {
        if (~this.group[i].name.indexOf("overhang")) {
          this.group[i].data = { id: i, overhang: true };
          this.overhang_group_data.push(this.group[i].data);
        } else if (~this.group[i].name.indexOf("support")) {
          this.group[i].data = { id: this.group[i].parent, support: true };
        } else {
        }
      }
    }
  }
};
Mesh.prototype.decodeOverhangBoundariesContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_OVERHANG_BOUNDARIES) == 0) {
    //log("No overhang boundaries data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  }
  var digits = 6;
  var accuracy = Math.pow(10, digits);
  var content_size = this.readInt();
  var n_boundaries = this.readInt();
  this.overhang_boundaries = [];

  for (var i = 0; i < n_boundaries; i++) {
    var min_x = Number.POSITIVE_INFINITY;
    var min_y = Number.POSITIVE_INFINITY;
    var max_x = Number.NEGATIVE_INFINITY;
    var max_y = Number.NEGATIVE_INFINITY;
    var n_contours = this.readInt();
    var contours = [];
    for (var j = 0; j < n_contours; j++) {
      var contour = [];
      var n_vertices = this.readInt();
      for (var k = 0; k < n_vertices; k++) {
        var v = this.readInt();
        var x =
          Math.round(
            (parseFloat(this.v[3 * v]) + 1) * (this.scale / 2) * accuracy
          ) / accuracy;
        var y =
          Math.round(
            (parseFloat(this.v[3 * v + 1]) + 1) * (this.scale / 2) * accuracy
          ) / accuracy;
        if (x < min_x) min_x = x;
        if (x > max_x) max_x = x;
        if (y < min_y) min_y = y;
        if (y < max_y) max_y = y;
        contour.push([x, y]);
      }
      if (contour.length > 2) {
        contours.push(contour);
      }
    }
    this.overhang_group_data[i].dim = {
      min_x: min_x,
      max_x: max_x,
      min_y: min_y,
      max_y: max_y,
    };
    this.overhang_group_data[i].contours = contours;
    this.overhang_boundaries.push(contours);
  }
  this.alignToByte();
  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.decodeFeature = function () {
  var total_bit_size = this.readInt();
  var feature = { type: 0, name: "" };
  feature.type = this.readBits(32);
  var name_len = this.readBits(32);
  feature.name = this.readString(name_len);
  feature.orientation = this.readBits(8);
  feature.dimension = this.readFloat();
  feature.set = this.readBits(32);
  return feature;
};

Mesh.prototype.decodeFeaturesContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_FEATURES) == 0) {
    //log("No feature data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  }
  var gravity_center = {};
  gravity_center.x = this.readFloat();
  gravity_center.y = this.readFloat();
  gravity_center.z = this.readFloat();
  this.features_size = this.readBits(32);
  this.n_feature = this.readBits(32);
  this.features = [];
  for (var i = 0; i < this.n_feature; i++) {
    var feature = this.decodeFeature();
    feature.id = i;
    this.features.push(feature);
  }
  var feature_id_len = this.readBits(32);
  this.feature_map = new Array(this.face_count);
  var feature_none = (1 << feature_id_len) - 1;
  for (var i = 0; i < this.face_count; i++) {
    var feature_id = this.readBits(feature_id_len);
    if (feature_id != feature_none) this.feature_map[i] = feature_id;
    else this.feature_map[i] = -1;
  }
  setTimeout(function () {
    done();
  }, 0);
  this.alignToByte();
};

Mesh.prototype.decodeMarkup = function () {
  var mk_len = this.readBits(32);
  var markup = {};
  markup.type = this.readBits(32);
  markup.tolerance = this.readFloat();
  markup.n_text = this.readBits(32);
  markup.text = [];
  for (var i = 0; i < markup.n_text; i++) {
    var len = this.readBits(32);
    var str = this.readUTF8String(len);
    markup.text.push(str);
  }
  markup.n_marked = this.readBits(32);
  markup.marked = [];
  for (var i = 0; i < markup.n_marked; i++) {
    var link = {};
    link.type = this.readBits(32);
    link.id = this.readBits(32);
    markup.marked.push(link);
  }
  markup.n_polyline = this.readBits(32);
  markup.polyline = [];
  var s = 1.0 / (1 << (this.vertex_qbits - 1));
  for (var i = 0; i < markup.n_polyline; i++) {
    var polyline = {};
    polyline.n = this.readBits(32);
    //log("new: " + polyline.n + " " + this.vertex_qbits);
    polyline.coords = new Array();
    for (var j = 0; j < polyline.n; j++) {
      var qCoord = this.readBits(this.vertex_qbits);
      polyline.coords[j] = (qCoord + 0.5) * s - 1.0;
      //polyline.coords[j] = this.readFloat();
    }
    markup.polyline.push(polyline);
  }
  return markup;
};

Mesh.prototype.decodeMarkupsContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_MARKUPS) == 0) {
    //log("No markup data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  }
  var markup_size = this.readBits(32);
  var gp_len = this.readBits(32);
  this.n_markup = this.readBits(32);
  this.markups = [];
  for (var i = 0; i < this.n_markup; i++) {
    var markup = this.decodeMarkup();
    this.markups.push(markup);
  }
  setTimeout(function () {
    done();
  }, 0);
  this.alignToByte();
};

Mesh.prototype.decodeGroupContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_GROUPS) == 0) {
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  } else {
    this.group_size = this.readInt();
    this.group_count = this.readInt();

    var ilog2 = function (m) {
      for (var i = 0; m != 0; i++) m >>= 1;
      return i;
    };
    var group_index_bits = ilog2(this.group_count + 1);
    var group_none_symbol = (1 << group_index_bits) - 1;

    this.group = new Array();

    for (var j = 0; j < this.group_count; j++) {
      var gi = this.readBits(group_index_bits);
      if (gi >= this.group_count) gi = -1;
      if (gi == group_none_symbol) gi = -1;
      var name_len = this.readBits(32);
      var name = this.readString(name_len);
      this.group[j] = { parent: gi, name: name };
    }

    this.initializeOverhangGroups();

    this.face_gi = new Array();

    for (var j = 0; j < this.face_count; j++) {
      var gi = this.readBits(group_index_bits);
      if (gi >= this.group_count) gi = -1;
      if (gi == group_none_symbol) gi = -1;
      this.face_gi[j] = gi;
    }
    this.alignToByte();
  }

  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.decodeCurveContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_CURVE) == 0) {
    //log("No curve data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  } else {
    this.curve_size = this.readInt();
    this.curve_count = this.readInt();
    this.curve_size -= 4;
    this.curve_vcount = this.readInt();
    this.curve_size -= 4;
    //log("curve_count: " + this.curve_count);
    //log("curve_vcount: " + this.curve_vcount);
  }

  //log("decode " + this.curve_count + " curves on " + this.vertex_ibits + " bits");
  var i;
  this.curve_vn = [];
  this.curve_vn.length = this.curve_count;
  this.curve = [];
  this.curve.length = this.curve_count;
  for (i = 0; i < this.curve_count; i++) {
    this.curve_vn[i] = this.readBits(this.vertex_ibits);
    this.curve[i] = [];
    this.curve[i].lenth = this.curve_vn[i];

    for (var j = 0; j < this.curve_vn[i]; j++) {
      i0 = this.readBits(this.vertex_ibits);
      this.curve[i].push(i0);
    }
  }
  this.alignToByte();

  if ((this.content & Mesh.SVM_CONTENT_NURBS) != 0) {
    //log("skip nurbs content");
    this.nurbs_size = this.readInt();
    this.data.skip(this.nurbs_size * 8);
  }

  //log("done");

  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.decodeFontContent = function (done, abort) {
  if ((this.content & Mesh.SVM_CONTENT_FONT) == 0) {
    //log("No font data");
    setTimeout(function () {
      done([]);
    }, 0);
    return;
  }

  this.font_size = this.readInt();
  //log("font size: " + this.font_size);
  var glyph_count = this.readInt();
  this.font_size -= 4;
  //log("glyph_count: " + glyph_count);

  //log("decode " + glyph_count + " glyphs");
  var i;
  this.font = { stride: [], charmap: {} };

  for (i = 0; i < glyph_count; i++) {
    var charcode = this.readInt();
    this.font.charmap[String.fromCharCode(charcode)] = i;
  }

  for (i = 0; i < glyph_count; i++) {
    var stride = this.readFloat();
    this.font.stride.push(stride);
  }

  //log("done");

  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.decodeLasercut = function (done, abort) {
  this.lsr_flags = this.readInt();

  if (this.content & Mesh.SVM_CONTENT_LASERCUT_PROPERTIES) {
    var prop = this.readByte();

    if (prop & Mesh.SVM_LASERCUT_PROPERTY_NUM_OBJECTS) {
      var num_objects = this.readInt();
    }
  }

  this.point_count = 0;
  this.path_count = 0;
  this.shape_count = 0;

  if (this.content & Mesh.SVM_CONTENT_LASERCUT_POINTS) {
    var point_size = this.readInt();
    this.point_count = this.readInt();

    point_size -= 4;

    this.points = [];

    for (var i = 0; i < this.point_count; ++i) {
      var x = this.readFloat();
      var y = this.readFloat();

      this.points.push({
        x: x,
        y: y,
      });
    }

    var flag_bits = this.readBits(5);

    for (var i = 0; i < this.point_count; ++i) {
      this.points[i]["flags"] = this.readBits(flag_bits);
    }
  }

  this.alignToByte();

  var ilog2 = function (m) {
    for (var i = 0; m != 0; i++) m >>= 1;
    return i;
  };

  this.point_ibits = ilog2(this.point_count);

  if (this.content & Mesh.SVM_CONTENT_LASERCUT_PATHS) {
    var path_size = this.readInt();

    this.path_count = this.readInt();

    path_size -= 4;

    var flag_bits = this.readBits(5);

    this.paths = [];

    for (var i = 0; i < this.path_count; ++i) {
      var flags = this.readBits(flag_bits);
      var pi = this.readBits(this.point_ibits);
      var pn = this.readBits(this.point_ibits);

      this.paths.push({
        flags: flags,
        pi: pi,
        pn: pn,
      });
    }
  }
  this.alignToByte();

  this.path_ibits = ilog2(this.path_count);

  if (this.content & Mesh.SVM_CONTENT_LASERCUT_SHAPES) {
    var shape_size = this.readInt();

    this.shape_count = this.readInt();

    shape_size -= 4;

    this.shapes = [];

    var flag_bits = this.readBits(5);
    var cut_type_bits = 0;

    if (this.lsr_flags & Mesh.LSR_CONFORMANT) {
      cut_type_bits = this.readBits(5);
    }
    for (var i = 0; i < this.shape_count; ++i) {
      var flags = this.readBits(flag_bits);
      var ti = this.readBits(this.path_ibits);
      var tn = this.readBits(this.path_ibits);

      var stroke = null;
      var fill = null;
      var line_width = null;
      var stroke_type = null;
      var fill_type = null;

      if (flags & Mesh.LSR_SHAPE_FLAG_STROKE_COLOR) {
        stroke = {
          r: this.readBits(8),
          g: this.readBits(8),
          b: this.readBits(8),
          a: this.readBits(8),
        };
      }

      if (flags & Mesh.LSR_SHAPE_FLAG_FILL_COLOR) {
        fill = {
          r: this.readBits(8),
          g: this.readBits(8),
          b: this.readBits(8),
          a: this.readBits(8),
        };
      }

      if (flags & Mesh.LSR_SHAPE_FLAG_LINE_WIDTH) {
        line_width = this.data.readFloat();
      }

      if (this.lsr_flags & Mesh.LSR_CONFORMANT) {
        stroke_type = this.readBits(cut_type_bits);
        fill_type = this.readBits(cut_type_bits);
      }

      this.shapes.push({
        flags: flags,
        ti: ti,
        tn: tn,
        stroke: stroke,
        fill: fill,
        line_width: line_width,
        stroke_type: stroke_type,
        fill_type: fill_type,
      });
    }
  }

  setTimeout(function () {
    done();
  }, 0);
};

Mesh.prototype.decode = function (success, failure, abort) {
  if (!this.magic()) {
    failure("Bad magic");
    return;
  }
  var _this = this;

  this.version = this.readInt();
  /*	if (this.version != 1) {
		failure("Only support SVM version 1...");
		return;
	}*/
  this.content = this.readInt();
  this.flags = this.readInt();
  this.center_x = this.readFloat();
  this.center_y = this.readFloat();
  this.center_z = this.readFloat();
  this.scale = this.readFloat();
  //log("SVM version " + this.version);
  if ((this.flags & Mesh.SVM_FLAGS_LASERCUT) != 0) {
    this.decodeLasercut(function () {
      success(_this);
    }, abort);
    return;
  }
  //if ((this.content & Mesh.SVM_CONTENT_VERTEX) != 0)
  //log("has vertex data");
  //if ((this.content & Mesh.SVM_CONTENT_FACE) != 0)
  //log("has face data");
  //if ((this.content & Mesh.SVM_CONTENT_MATERIAL) != 0)
  //log("has material data");
  //if ((this.content & Mesh.SVM_CONTENT_NORMAL) != 0)
  //log("has normal vector data");
  //if ((this.content & Mesh.SVM_CONTENT_BSP) != 0)
  //log("has BSP tree");
  //if ((this.content & Mesh.SVM_CONTENT_VCOLOR) != 0)
  //log("has vertex color");
  //if ((this.content & Mesh.SVM_CONTENT_GROUPS) != 0)
  //log("has group data");
  //if ((this.content & Mesh.SVM_CONTENT_CURVE) != 0)
  //log("has curves");
  //if ((this.content & Mesh.SVM_CONTENT_SLICES) != 0)
  //log("has slices");
  //if ((this.content & Mesh.SVM_CONTENT_FEATURES) != 0)
  //log("has features");
  //if ((this.content & Mesh.SVM_CONTENT_MARKUPS) != 0)
  //log("has markups");

  //if ((this.flags & Mesh.SVM_FLAGS_ZLIB) != 0)
  //log("using zlib compression");
  //else
  //log("no compression");

  //if ((this.flags & Mesh.SVM_FLAGS_JPEG) != 0)
  //log("using JPEG texture compression");
  //else
  //log("using no texture compression");

  //if ((this.flags & Mesh.SVM_FLAGS_EXACT) != 0)
  //log("lossless mode");
  //else
  //log("lossy mode");

  //log("center " + this.center_x + "," + this.center_y + "," + this.center_z);
  //log("scale " + this.scale);

  //log("decode face");
  this.decodeFaceContent(function (indices) {
    //log("decode material");
    _this.decodeMaterialContent(function () {
      //log("decode vertex");
      _this.decodeVertexContent(
        indices,
        function (vertex) {
          //log("decode curve");
          _this.v = vertex;
          _this.f = indices;
          //log("vertex " + _this.v.length + " indices " + _this.f.length);
          _this.decodeVertexColorContent(function () {
            _this.decodeGroupContent(function () {
              _this.decodeCurveContent(function () {
                _this.decodeFontContent(function () {
                  _this.decodeSliceContent(function () {
                    _this.decodeFeaturesContent(function () {
                      _this.decodeMarkupsContent(function () {
                        _this.decodeOverhangBoundariesContent(function () {
                          success(_this);
                        }, abort);
                      }, abort);
                    }, abort);
                  }, abort);
                }, abort);
              }, abort);
            }, abort);
          }, abort);
        },
        abort
      );
    }, abort);
  }, abort);
};

Mesh.prototype.decodeSlice = function (success, failure, abort) {
  if (!this.magic()) {
    failure("Bad magic");
    return;
  }
  this.version = this.readInt();
  this.content = this.readInt();
  this.flags = this.readInt();
  this.center_x = this.readFloat();
  this.center_y = this.readFloat();
  this.center_z = this.readFloat();
  this.scale = this.readFloat();
  //log("SVM version " + this.version);
  //log("center " + this.center_x + "," + this.center_y + "," + this.center_z);
  //log("scale " + this.scale);
  var _this = this;
  _this.decodeSliceContent(function () {
    success(_this);
  }, abort);
};

var Triangle = function () {};

Triangle.prototype.computeNormal = function () {
  // calculate the vectors A and B
  // note that v[3] is defined with counterclockwise winding in mind
  var ux = this.ax - this.bx;
  var uy = this.ay - this.by;
  var uz = this.az - this.bz;

  var vx = this.bx - this.cx;
  var vy = this.by - this.cy;
  var vz = this.bz - this.cz;

  // calculate the cross product and place the resulting vector
  // into the address specified by vertex_t *normal
  this.nx = uy * vz - uz * vy;
  this.ny = uz * vx - ux * vz;
  this.nz = ux * vy - uy * vx;

  // calculate the length of the vector
  var len = Math.sqrt(
    this.nx * this.nx + this.ny * this.ny + this.nz * this.nz
  );
  // avoid division by 0
  if (len == 0.0) len = 1.0;

  // reduce to unit size
  this.nx /= len;
  this.ny /= len;
  this.nz /= len;
};

Mesh.prototype.magic = function () {
  var magic = this.readInt();
  if (magic != 0x53564d3d) {
    throw new Error("Bad Magic ! " + magic);
  }
  return true;
};
Mesh.prototype.readInt = function () {
  return this.data.readAUInt32();
  //	return (this.data.charCodeAt(this.idx++) << 24) + (this.data.charCodeAt(this.idx++) << 16) + (this.data.charCodeAt(this.idx++) << 8) + (this.data.charCodeAt(this.idx++));
};

Mesh.prototype.readVarInt = function () {
  return this.data.readVarInt();
};

Mesh.prototype.readByte = function () {
  return this.data.readAUInt8();
  //return (this.data.charCodeAt(this.idx++));
};

Mesh.prototype.readUnsignedShort = function () {
  return this.data.readAUInt16();
  //return (this.data.charCodeAt(this.idx++) << 8) + (this.data.charCodeAt(this.idx++));
};

Mesh.prototype.readFloat = function () {
  return this.data.readAFloat();
};
Mesh.prototype.readBits = function (count) {
  return this.data.readBits(count);
};
Mesh.prototype.readArrayOfBits = function (bits, count) {
  return this.data.readArrayOfBits(bits, count);
};
Mesh.prototype.readArrayOfShorts = function (bits, count) {
  return this.data.readArrayOfShorts(bits, count);
};
Mesh.prototype.readString = function (count) {
  return this.data.readString(count);
};
Mesh.prototype.readUTF8String = function (count) {
  return this.data.readUTF8String(count);
};
Mesh.prototype.readBase64String = function (count) {
  return this.data.readBase64String(count);
};
Mesh.prototype.alignToByte = function (count) {
  return this.data.alignToByte();
};

var EdgeBreaker = function (data) {
  this.stack = new Array();
  this.data = data;
};

EdgeBreaker.SVM_EB_C = 0; /* 0 */
EdgeBreaker.SVM_EB_L = 6; /* 110 */
EdgeBreaker.SVM_EB_E = 7; /* 111 */
EdgeBreaker.SVM_EB_R = 5; /* 101 */
EdgeBreaker.SVM_EB_S = 4; /* 100 */

/* face/corner encoding */
EdgeBreaker.prototype.FC_F = function (fv) {
  return fv >> 2;
};
EdgeBreaker.prototype.FC_C = function (fv) {
  return fv & 3;
};
EdgeBreaker.prototype.FCN = function (fv) {
  return (fv & 3) == 2 ? fv - 2 : fv + 1;
};
EdgeBreaker.prototype.FCP = function (fv) {
  return (fv & 3) == 0 ? fv + 2 : fv - 1;
};
EdgeBreaker.prototype.FCN_C = function (fv) {
  return (fv & 3) == 2 ? 0 : (fv & 3) + 1;
};
EdgeBreaker.prototype.FCP_C = function (fv) {
  return (fv & 3) == 0 ? 2 : (fv & 3) - 1;
};
EdgeBreaker.prototype.FC = function (f, v) {
  return (f << 2) | (v & 3);
};

EdgeBreaker.prototype.ilog2 = function (m) {
  for (var i = 0; m != 0; i++) m >>= 1;
  return i;
};

EdgeBreaker.prototype.dbg_eb = function (s) {
  //log(s);
};

EdgeBreaker.prototype.dump_O = function (n) {
  //for (var i = 0; i < n; i++)
  //log("O[" + i + "] = " + O[0+4*i] + "," + O[1+4*i] + "," + O[2+4*i] + " (" +
  //		   FC_F(O[0+4*i]) + "/" + FC_C(O[0+4*i]) + "," +
  //		   FC_F(O[1+4*i]) + "/" + FC_C(O[1+4*i]) + "," +
  //		   FC_F(O[2+4*i]) + "/" + FC_C(O[2+4*i]) + ")");
};

EdgeBreaker.prototype.dump_V = function (n) {
  //for (var i = 0; i < n; i++)
  //log("V[" + i + "] = " + V[0+4*i] + "," + V[1+4*i] + "," +  V[2+4*i]);
};

/* connectivity */
EdgeBreaker.prototype.ebZip = function (c) {
  var a, b;
  var V = this.V;
  var O = this.O;

  do {
    if (this.ebCheckHandle(c)) {
      /* no zip at handle */
      //dbg_eb("no zip at handle" + FC_F(c) + "/" + FC_C(c));
      return;
    }

    /* look clockwise for free edge */
    b = (c & 3) == 2 ? c - 2 : c + 1;

    while (O[b] >= 0 && O[b] != c) {
      b = O[b];
      b = (b & 3) == 2 ? b - 2 : b + 1;
    }

    if (O[b] != -1) {
      /* no zip possible */
      return;
    }

    /* assign opposites */
    O[c] = b;
    O[b] = c;

    /* assign co-incident corners */
    a = (c & 3) == 2 ? c - 2 : c + 1;

    V[(a & 3) == 2 ? a - 2 : a + 1] = V[(b & 3) == 2 ? b - 2 : b + 1];
    while (O[a] >= 0 && b != a) {
      a = O[a];
      a = (a & 3) == 2 ? a - 2 : a + 1;
      V[(a & 3) == 2 ? a - 2 : a + 1] = V[(b & 3) == 2 ? b - 2 : b + 1];
    }

    /* find corner of next free edge on right */
    c = (c & 3) == 0 ? c + 2 : c - 1;
    while (O[c] >= 0 && c != b) {
      c = O[c];
      c = (c & 3) == 0 ? c + 2 : c - 1;
    }
  } while (O[c] == -2);
};

EdgeBreaker.prototype.ebCheckHandle = function (c) {
  var a, h;
  var H = this.H;
  var O = this.O;
  var gh = this.gh;
  var hn = this.hn;

  if (gh >= hn || c != H[1][gh]) return false;

  //dbg_eb(gh + ": found handle at " + FC_F(c) + "/" + FC_C(c) + " with " + FC_F(H[0][gh]) + "/" + FC_C(H[0][gh]));

  /* link opposite corners */
  O[c] = H[0][gh];
  O[H[0][gh]] = c;

  /* find corner of next free edge if any */
  a = (c & 3) == 0 ? c + 2 : c - 1;
  while (O[a] >= 0 && a != H[0][gh]) {
    //dbg_eb("a = " + FC_F(a) + "/" + FC_C(a) + " O=" + O[FC_C(a)+4*FC_F(a)]);
    //dbg_eb("H[0][gh] = " + FC_F(H[0][gh]) + "/" + FC_C(H[0][gh]));
    a = O[a];
    a = (a & 3) == 0 ? a + 2 : a - 1;
  }

  /* next handle */
  h = ++gh;

  //dbg_eb("stop at a = " + FC_F(a) + "/" + FC_C(a) + " O=" + O[FC_C(a)+4*FC_F(a)]);

  /* zip if found cw edge */
  this.gh = gh;
  if (O[a] == -2) this.ebZip(a);

  /* find corner of next free edge if any */
  a = O[c];
  a = (a & 3) == 0 ? a + 2 : a - 1;
  while (O[a] >= 0 && a != c) {
    //dbg_eb("a = " + FC_F(a) + "/" + FC_C(a) + " O=" + O[FC_C(a)+4*FC_F(a)]);
    //dbg_eb("c = " + FC_F(c) + "/" + FC_C(c));
    a = O[a];
    a = (a & 3) == 0 ? a + 2 : a - 1;
  }

  //dbg_eb("stop at a = " + FC_F(a) + "/" + FC_C(a) + " O=" + O[FC_C(a)+4*FC_F(a)]);

  /* zip if found cw edge */
  this.gh = gh;
  if (O[a] == -2) this.ebZip(a);

  //dbg_eb("zipped");

  /* restore handle pointer */
  gh = h;
  this.gh = gh;

  return true;
};

EdgeBreaker.prototype.ebDecodeConnectivity = function (c) {
  var O = this.O;
  var V = this.V;

  while (true) {
    var s;

    // add triangle
    this.gt++;

    //dbg_eb("t = " + gt);

    // link opposite
    O[c] = 4 * this.gt;
    O[4 * this.gt] = c;

    // set index of shared vertices
    V[1 + 4 * this.gt] = V[(c & 3) == 0 ? c + 2 : c - 1];
    V[2 + 4 * this.gt] = V[(c & 3) == 2 ? c - 2 : c + 1];
    c = 4 * this.gt + 1;
    var cn = (c & 3) == 2 ? c - 2 : c + 1;

    // read symbol
    s = this.readBits(1);
    if (s == 0) {
      //dbg_eb("C");
      this.gn++;
      O[cn] = -1;
      V[0 + 4 * this.gt] = this.gn;
    } else {
      s = this.readBits(2);
      switch (s) {
        case 2:
          //dbg_eb("L");
          O[cn] = -2;
          this.ebZip(cn);
          break;

        case 1:
          //dbg_eb("R");
          O[c] = -2;
          this.ebCheckHandle(c);
          // go left
          c = cn;
          break;

        case 0:
          //dbg_eb("S");
          //dbg_eb("corner = " + FC_F(c) + "/" + FC_C(c));
          // push left and go right
          this.stack.push(cn);
          break;

        case 3:
          //dbg_eb("E");
          O[cn] = -2;
          O[c] = -2;

          this.ebCheckHandle(c);
          this.ebZip(cn);
          do {
            if (!this.stack.length) return;
            else c = this.stack.pop();
            // if the triangle to the left was visited, then pop
          } while (O[c] >= 0);
          break;
      }
    }
  }
};

EdgeBreaker.prototype.ebDecodeVertices = function (c) {
  var v0, v1, v2;
  var o, l, r;
  var ip, ic, _in, ir, il, io;
  var f;
  var M = this.M;
  var U = this.U;
  var O = this.O;
  var V = this.V;
  var vqbits = this.vqbits;
  var vq = this.vq;

  while (true) {
    f = c >> 2;
    var cn = (c & 3) == 2 ? c - 2 : c + 1;
    var cp = (c & 3) == 0 ? c + 2 : c - 1;

    ip = V[cp]; // previous
    ic = V[c]; // current
    _in = V[cn]; // next
    l = O[cp];
    o = O[c];
    r = O[cn];
    il = V[l]; // left
    io = V[o]; // opposite
    ir = V[r]; // right

    U[f] = true; /* mark triangle */

    if (M[ic] == false) {
      /* new vertex */
      this.gn++;

      //dbg_eb("C");

      v0 = this.readBits(vqbits + 2);
      v1 = this.readBits(vqbits + 2);
      v2 = this.readBits(vqbits + 2);

      vq[0][this.gn] =
        vq[0][ip] + vq[0][_in] - vq[0][io] + (v0 - (1 << (vqbits + 1)));
      vq[1][this.gn] =
        vq[1][ip] + vq[1][_in] - vq[1][io] + (v1 - (1 << (vqbits + 1)));
      vq[2][this.gn] =
        vq[2][ip] + vq[2][_in] - vq[2][io] + (v2 - (1 << (vqbits + 1)));

      /* mark vertex as visited */
      M[ic] = true;

      /* turn right */
      return r;
    } else {
      var rv, lv;

      rv = U[r >> 2]; /* right triangle visited */
      lv = U[l >> 2]; /* right triangle visited */

      if (rv) {
        if (lv) {
          /* both visited: end */
          //dbg_eb("E");
          do {
            if (this.stack.length == 0) return -1 /* done */;
            else c = this.stack.pop();
            /* if the triangle to the left was visited, then return	*/
          } while (U[c >> 2]);
        } else {
          /* right visited: go left */
          //dbg_eb("R");
          c = l;
        }
      } else {
        if (lv) {
          /* left visited: go right */
          //dbg_eb("L");
          c = r;
        } else {
          /* none visited: go right, push left */
          //dbg_eb("S");
          this.stack.push(l);
          c = r;
        }
      }
    }
  }
};

EdgeBreaker.prototype.getVertices = function (vertex) {
  var i;
  var M = this.M;
  var vq = this.vq;
  var vqbits = this.vqbits;

  for (i = this.gn + 1; i < this.vn; i++) {
    this.gn++;
    vq[0][this.gn] = this.readBits(vqbits);
    vq[1][this.gn] = this.readBits(vqbits);
    vq[2][this.gn] = this.readBits(vqbits);
    M[this.gn] = true;
  }

  for (i = 0; i < this.vn; i++) {
    vertex[3 * i + 0] = (vq[0][i] + 0.5) / (1 << (vqbits - 1)) - 1.0;
    vertex[3 * i + 1] = (vq[1][i] + 0.5) / (1 << (vqbits - 1)) - 1.0;
    vertex[3 * i + 2] = (vq[2][i] + 0.5) / (1 << (vqbits - 1)) - 1.0;
  }
};

EdgeBreaker.prototype.decodeConnectivity = function (fn, hn) {
  var i;
  var FC = this.FC;

  this.fn = fn;
  this.hn = hn;

  hbits = this.ilog2(3 * fn);

  // read handle table
  var H = new Array(2);
  this.H = H;
  H[0] = new Array(hn);
  H[1] = new Array(hn);
  //dbg_eb("hbits " + hbits);
  for (i = 0; i < hn; i++) {
    var h;

    h = this.readBits(hbits);
    //dbg_eb("h = " + h);
    H[0][i] = FC(h / 3, h % 3);
    h = this.readBits(hbits);
    //dbg_eb("h = " + h);
    H[1][i] = FC(h / 3, h % 3);

    //dbg_eb("HANDLE " + FC_F(H[0][i]) + "/" + FC_C(H[0][i]) + " " + FC_F(H[1][i]) + "/" + FC_C(H[1][i]));
  }
  // align to byte
  if ((2 * hbits * hn) % 8 != 0) {
    //dbg_eb("align = " + (8 - (2 * hbits * hn % 8)));
    this.readBits(8 - ((2 * hbits * hn) % 8));
  }

  var V = new Array(4 * fn);
  this.V = V;

  var O = new Array(4 * fn);
  this.O = O;

  for (i = 0; i < fn; i++) V[0 + 4 * i] = 0;
  for (i = 0; i < fn; i++) V[1 + 4 * i] = 0;
  for (i = 0; i < fn; i++) V[2 + 4 * i] = 0;
  for (i = 0; i < fn; i++) O[0 + 4 * i] = -3;
  for (i = 0; i < fn; i++) O[1 + 4 * i] = -3;
  for (i = 0; i < fn; i++) O[2 + 4 * i] = -3;

  this.gt = -1;
  this.gn = -1;
  this.gh = 0;
  this.gs = 0;

  while (this.gt + 1 < fn) {
    this.gs++;
    this.gt++;

    V[0 + 4 * this.gt] = ++this.gn;
    V[1 + 4 * this.gt] = ++this.gn;
    V[2 + 4 * this.gt] = ++this.gn;
    O[0 + 4 * this.gt] = -3;
    O[1 + 4 * this.gt] = -1;
    O[2 + 4 * this.gt] = -1;

    var t = new Date().getTime();
    this.ebDecodeConnectivity(FC(this.gt, 0));
    ////log("decoded strip in " + ((new Date()).getTime() - t) + " ms");

    //this.dbg_eb("Decoded " + (this.gt + 1) + "/" + this.fn + " faces");
  }

  return 0;
};

EdgeBreaker.prototype.decodeVertexInit = function (vn, vqbits) {
  var i;

  this.vn = vn;
  this.vqbits = vqbits;

  var U = new Array(this.fn);
  this.U = U;
  var M = new Array(vn);
  this.M = M;

  for (i = 0; i < this.fn; i++) U[i] = false;

  for (i = 0; i < this.vn; i++) M[i] = false;

  var vq = new Array(3);
  this.vq = vq;
  for (i = 0; i < 3; i++) vq[i] = new Array(vn);

  this.gt = 0;
  this.gn = -1;
  this.gc = -1;
};

EdgeBreaker.prototype.decodeNextTriangle = function () {
  var U = this.U;
  var M = this.M;
  var O = this.O;
  var V = this.V;
  var vq = this.vq;
  var vqbits = this.vqbits;

  //dbg_eb("decodeNextTriangle");

  if (this.gt >= this.fn) {
    //log("no more triangles");
    return -1;
  }

  while (true) {
    if (this.gc == -1) {
      var v0, v1, v2;

      U[this.gt] = true;

      this.gn++;
      v0 = this.readBits(vqbits);
      v1 = this.readBits(vqbits);
      v2 = this.readBits(vqbits);
      this.vq[0][this.gn] = v0;
      this.vq[1][this.gn] = v1;
      this.vq[2][this.gn] = v2;
      this.M[this.gn] = true;

      this.gn++;
      v0 = this.readBits(vqbits + 1);
      v1 = this.readBits(vqbits + 1);
      v2 = this.readBits(vqbits + 1);
      vq[0][this.gn] = vq[0][this.gn - 1] + v0 - (1 << vqbits);
      vq[1][this.gn] = vq[1][this.gn - 1] + v1 - (1 << vqbits);
      vq[2][this.gn] = vq[2][this.gn - 1] + v2 - (1 << vqbits);
      M[this.gn] = true;

      this.gn++;
      v0 = this.readBits(vqbits + 1);
      v1 = this.readBits(vqbits + 1);
      v2 = this.readBits(vqbits + 1);
      vq[0][this.gn] = vq[0][this.gn - 1] + v0 - (1 << vqbits);
      vq[1][this.gn] = vq[1][this.gn - 1] + v1 - (1 << vqbits);
      vq[2][this.gn] = vq[2][this.gn - 1] + v2 - (1 << vqbits);
      M[this.gn] = true;

      this.gc = O[0 + 4 * this.gt];
      this.gt++;
      return 0;
    }

    //dbg_eb("V = " + V[0+4*gt] + " " + V[1+4*gt] + " " + V[2+4*gt] + " gn=" + this.gn);

    if (
      V[0 + 4 * this.gt] <= this.gn &&
      V[1 + 4 * this.gt] <= this.gn &&
      V[2 + 4 * this.gt] <= this.gn
    ) {
      this.gt++;
      return 0;
    }

    /* decode new vertices */
    this.gc = this.ebDecodeVertices(this.gc);
  }

  return 0;
};

EdgeBreaker.prototype.readBits = function (count) {
  return this.data.readBits(count);
};
